module.exports = __webpack_public_path__ + "img/like.8c6b047a.svg";